import UserAddress from './index'

export default { path: '/home/address', component: UserAddress }
